import React, { PropsWithChildren } from 'react'

import { useLocation } from 'react-router-dom'

import { ConditionalRouterLink } from '@components/UI/ConditionalLink/ConditionalLink'
import { useModal } from '@context/Modal'
import { EventTrackingNames, PageRoutes } from '@enums'
import { objectToQueryString } from '@utils'
import BrandFansGroupRowTrackedRoute from '../TrackedRoute'
import NoCreatorsModal from './NoCreatorsModal'

interface IProps {
  groupId: number
  eventName: EventTrackingNames
  canCreateCampaign: boolean
  additionalProperties?: any
}

const BrandFansGroupRowCreateCampaignLink: React.FC<PropsWithChildren<IProps>> = ({
  groupId,
  canCreateCampaign,
  children,
  eventName,
  additionalProperties,
}) => {
  const { showModal } = useModal()
  const { pathname } = useLocation()
  const onClick = () => {
    showModal(NoCreatorsModal)
  }
  return (
    <div onClick={canCreateCampaign ? undefined : onClick} role="button">
      <BrandFansGroupRowTrackedRoute
        hasTracking={canCreateCampaign}
        eventName={eventName}
        groupId={groupId}
        additionalProperties={additionalProperties}
      >
        <ConditionalRouterLink
          showLink={canCreateCampaign}
          to={{
            pathname: `/${PageRoutes.CampaignBuilder}`,
            search: objectToQueryString({
              brand_fan_group_id: groupId,
              from: pathname,
            }),
          }}
        >
          {children}
        </ConditionalRouterLink>
      </BrandFansGroupRowTrackedRoute>
    </div>
  )
}

export { BrandFansGroupRowCreateCampaignLink }
export default BrandFansGroupRowCreateCampaignLink
